import { reactive } from 'vue';
export const giftStatuses = reactive({});
export function giftStatusKey(userID, giftID) { return `${userID}:${giftID}`; }
export function saveGiftStatus(userID, gift) { if (gift?.request_id) giftStatuses[giftStatusKey(userID,gift.request_id)] = gift; }
